
var ToastrController    = new (require('../services/ToastrController'));

function PreventSendingMultipleRequestsController() {

    this.overlay = new (require('./overlay'))();
    this.$submitButton = $('.prevent-multiple-requests');
    this.$form = $('form');

    var self = this; // Needed for using all constructor variables inside this function, note the differece -> no "this" but "var" at the beginning

    (function () {

        self.$submitButton.click(function() {

            var canBeShown = true;

            self.$form.find('input, textarea, select').each(function(i, field) {
                if (field.value === '' && field.hasAttribute('required')) {
                    canBeShown = false;
                }
            });

            if (canBeShown == true) {
                self.overlay.showOverlay('Your request is processing. Please be patient... It usually takes few seconds');
            }
        });

    }());
}

module.exports = PreventSendingMultipleRequestsController;